import AOS from "aos";
export default class {
  constructor() {
    window.AOS = AOS;

    document.addEventListener("DOMContentLoaded", () => {
      let cssClasses = `
                .wp-block-image:not(.cult-logo-hover .wp-block-image),
                .BlockResults__resultTitle,
                .wp-block-cover:not(.SiteHeader__popout .wp-block-cover),
                .wp-block-column > p:not(.has-large-font-size),
                .BlockImagePhoto__wrapper .wp-block-column:last-child .wp-block-group__inner-container > *,
                .wp-block-heading:not(.BlockImageText .wp-block-heading),
                .BlockImageText .wp-block-group__inner-container,
                .BlockProjectList,
                .wp-block-video
                `.replace(/\n/g, "");
      document.querySelectorAll(cssClasses).forEach((el) => {
        const attributes = {
          "data-aos": "fade-up",
          "data-aos-duration": "600",
          "data-aos-once": "false",
        };
        Object.keys(attributes).forEach((key) => {
          el.setAttribute(key, attributes[key]);
        });
      });

      cssClasses = `
                .BlockResults__resultCopy,
                .wp-block-column > p.has-large-font-size
                `.replace(/\n/g, "");
      document.querySelectorAll(cssClasses).forEach((el) => {
        const attributes = {
          "data-aos": "fade-up",
          "data-aos-duration": "600",
          "data-aos-once": "false",
          "data-aos-delay": "100",
        };
        Object.keys(attributes).forEach((key) => {
          el.setAttribute(key, attributes[key]);
        });
      });
      this.init();
    });
  }

  init() {
    AOS.init();
  }
}
